import React from "react";

function extractVideoId(input) {
  if (!input) return null;
  const trimmed = input.trim();

  // Bare 11-char video ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;

  try {
    const url = new URL(trimmed);
    const host = url.hostname.replace("www.", "");

    if (host === "youtu.be") {
      const id = url.pathname.slice(1);
      return /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : null;
    }

    if (host === "youtube.com" || host === "youtube-nocookie.com") {
      // /watch?v=ID
      const v = url.searchParams.get("v");
      if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) return v;

      // /embed/ID or /shorts/ID
      const match = url.pathname.match(/^\/(embed|shorts)\/([a-zA-Z0-9_-]{11})/);
      if (match) return match[2];
    }
  } catch {
    // not a valid URL
  }

  return null;
}

const YouTubeBlock = {
  label: "YouTube",
  fields: {
    url: {
      type: "text",
      label: "YouTube URL or Video ID",
    },
    aspectRatio: {
      type: "radio",
      label: "Aspect Ratio",
      options: [
        { label: "16:9", value: "16/9" },
        { label: "4:3", value: "4/3" },
      ],
    },
    maxWidth: {
      type: "select",
      label: "Max Width",
      options: [
        { label: "Full width", value: "100%" },
        { label: "768px", value: "768px" },
        { label: "672px", value: "672px" },
        { label: "576px", value: "576px" },
      ],
    },
    align: {
      type: "radio",
      label: "Alignment",
      options: [
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
        { label: "Right", value: "right" },
      ],
    },
  },
  defaultProps: {
    url: "",
    aspectRatio: "16/9",
    maxWidth: "100%",
    align: "center",
  },
  render: ({ url, aspectRatio, maxWidth, align, puck }) => {
    const videoId = extractVideoId(url);

    const alignClass =
      align === "right"
        ? "ml-auto"
        : align === "center"
          ? "mx-auto"
          : "";

    if (!videoId) {
      if (!puck?.isEditing) return null;

      return (
        <div
          className={`border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 ${alignClass}`}
          style={{ maxWidth, aspectRatio, width: "100%" }}
        >
          Paste a YouTube URL to embed a video
        </div>
      );
    }

    return (
      <div className={alignClass} style={{ maxWidth, width: "100%" }}>
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}`}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ aspectRatio, width: "100%", border: 0 }}
        />
      </div>
    );
  },
};

export default YouTubeBlock;
